module.exports = __webpack_public_path__ + "img/sea.eef25d65.jpg";